import React from "react"
import Text from "@amzn/meridian/text";
import {TextProps} from "src/interfaces/props/CommonProps";

export class MediumText extends React.Component<TextProps> {

    constructor(props: TextProps) {
        super(props);
    }

    render() {
        return(
            <Text type="d50" breakWord={this.props.breakWord}> {this.props.text} </Text>
        );
    }
}

export default MediumText;